import React from 'react'
import Link from 'next/link'

import GImage from '../gImage'
import { useGlobalContext } from 'src/contexto/contextoGlobal'
import { OriginLoadingEnum } from 'src/util/enums/origin-loading'

export default function ItemDestaque(props) {
  const { setOriginLoading } = useGlobalContext()

  const closeDropdownCategoria = () => {
    const dropdown = document.querySelector('.dropdown-categoria')
    dropdown.classList.remove('active')
  }

  const LinkCategory = ({ asComplement, children }) => (
    <Link
      href="/categoria/[...categoria]"
      as={`/categoria/${asComplement}`}
      prefetch={false}
      onClick={() => {
        setOriginLoading(OriginLoadingEnum.CATEGORY)
        closeDropdownCategoria()
      }}
    >
      {children}
    </Link>
  )

  return (
    <div className={`cont-categoria ${props.isSelected ? 'show' : ''}`}>
      <div className="info">
        <h2>{props.title}</h2>
        <div className="all">
          {
            // Se não houver o parâmetro itens dentro de OPÇÕES = CATEGORIA, então, verifica se há parâmetros slug, etc. Se houver parâmetros quer dizer que existe apenas uma categoria no array, portanto, mostre apenas ela
            //Ocorre quando o Todas as categorias é selecionado e tem apenas uma categoria cadastrada
            !props.opcoes?.itens && props.opcoes?.parametros ? (
              <div className="item">
                <ul>
                  <li>
                    <LinkCategory
                      asComplement={props.opcoes.parametros.categoria_slug}
                    >
                      {props.opcoes.nome}
                    </LinkCategory>
                  </li>
                </ul>
              </div>
            ) : // Opções = Categorias;
            //Se tiver 1 ou mais categorias, significa que a opção selecionada é a mostrar todas as categorias, então, lista todas as categorias em uma só UL
            props?.opcoes && props?.opcoes?.length >= 1 ? (
              <div className="item">
                <ul>
                  {props.opcoes.map((categoria, key_categoria) => (
                    <li key={key_categoria + '-*'}>
                      <LinkCategory
                        asComplement={categoria.parametros.categoria_slug}
                      >
                        {categoria.nome}
                      </LinkCategory>
                    </li>
                  ))}
                </ul>
              </div>
            ) : //Caso não seja a opções TODAS AS CATEGORIAS ele irá realizar um for dentro de cada parâmetro itens de cada categoria
            props?.opcoes && props?.opcoes?.itens ? (
              //Cada categoria 2º nível está referenciada por um LI, caso a categoria possua um 3º nível, será criada uma DIV .item dentro contendo um UL e vários LI onde serão os itens de 3º nível
              <div className="item">
                <ul>
                  {props.opcoes.itens.map((subcategorias, key_subcategorias) =>
                    // Se não possuir elementos de 3º nível, mostra o nome com o Link - Vai mostrar todas as categorias que não possuem 3º nível agrupadas
                    subcategorias.qtde_itens < 1 ? (
                      <li key={subcategorias.id}>
                        <LinkCategory
                          asComplement={subcategorias.parametros.categoria_slug}
                        >
                          {subcategorias.nome}
                        </LinkCategory>
                      </li>
                    ) : (
                      // Se possuir 3º nível, cria uma DIV .item contendo uma UL e LI com os respectivos itens
                      <li key={key_subcategorias}>
                        <div className="item">
                          <h3>
                            <LinkCategory
                              asComplement={
                                subcategorias.parametros.categoria_slug
                              }
                            >
                              {subcategorias.nome}
                            </LinkCategory>
                          </h3>
                          <ul>
                            {subcategorias?.itens &&
                              subcategorias.itens.map(
                                (subItem, key_subItem) => (
                                  <li key={key_subItem}>
                                    <LinkCategory
                                      asComplement={
                                        subItem.parametros.categoria_slug
                                      }
                                    >
                                      {subItem.nome}
                                    </LinkCategory>
                                  </li>
                                )
                              )}
                          </ul>
                        </div>
                      </li>
                    )
                  )}
                </ul>
              </div>
            ) : (
              <></>
            )
          }
        </div>
      </div>

      <div className="banner-produto">
        {!props.title ||
        !props.opcoes ||
        !props.opcoes.banners ||
        !props.opcoes.banners[0] ? null : props.title !==
            'Todas as Categorias' &&
          props.opcoes.banners[0].banner.imagem_desktop ? (
          <Link
            href={`${props.opcoes.banners[0].banner.link.parametros.url}`}
            onClick={() => closeDropdownCategoria()}
            target={props.opcoes.banners[0].banner.link.target}
          >
            <GImage
              src={props.opcoes.banners[0].banner.imagem_desktop.url}
              alt={props.title}
              width={341}
              height={464}
              sizes="341px"
            />
          </Link>
        ) : null}
      </div>
    </div>
  )
}
